import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires GA4 + Meta Pixel pageview on every route change.
 * Silent no-op if trackers are not loaded (i.e., env IDs absent).
 */
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Meta Pixel
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
    // Google Analytics 4
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}
